import model_adherents from './model_adherents.csv'
import model_renouvellement from './model_renouvellement.csv'

const files = {
    model_adherents,
    model_renouvellement,
}

export default files
